import React from 'react'
import { Field } from 'formik'

import * as S from './styled'

const SearchEnginePreview = ({ path }) => {
    const categoryLink = slug =>
        `${process.env.REACT_APP_STOREFRONT_URL || window.location.origin}/${path}/${slug ||
            'category-url'}`

    return (
        <S.SearchEnginePreview>
            <S.SearchEngineUrl>
                <Field name="identifier">
                    {({ field }) => (
                        <>
                            <div className="!flex !flex-col" data-testid="full-seo-preview-link">
                                {categoryLink(field.value)}
                            </div>
                        </>
                    )}
                </Field>
            </S.SearchEngineUrl>
            <Field name="identifier">
                {({ field }) => (
                    <S.SearchEngineTitle
                        href={categoryLink(field.value)}
                        target="_blank"
                        data-testid="slug-preview-link"
                        className="!text-primary"
                    >
                        <Field name="metaTitle">
                            {({ field, form }) => {
                                if (field?.value?.length) {
                                    return field.value
                                } else {
                                    return form?.values?.name ? form.values.name : 'Category Name'
                                }
                            }}
                        </Field>
                    </S.SearchEngineTitle>
                )}
            </Field>

            <S.SearchEngineDescription data-testid="seo-preview-description">
                <Field name="metaDescription">
                    {({ field }) => {
                        if (field?.value?.length) {
                            return field.value
                        } else {
                            return (
                                <i>
                                    You have no description set. Descriptions are important and can
                                    influence click-through rates. The optimal length is between
                                    50–160 characters.
                                </i>
                            )
                        }
                    }}
                </Field>
            </S.SearchEngineDescription>
        </S.SearchEnginePreview>
    )
}

export default SearchEnginePreview
